import styles from './BackToTop.module.css'
import { BsArrowUpShort } from 'react-icons/bs'
import { useState, useEffect } from 'react'

const BackToTop = () => {

    const [showButton, setShowButton] = useState(false)

    const handleScroll = () => {
        if (window.pageYOffset > 500) { setShowButton(true) }
        else { setShowButton(false) }
    }

    const scrollToTop = () => {
        window.scrollTo({
            top:0,
            behavior:'smooth',
        })
    }

    useEffect(() => {
        window.addEventListener("scroll", handleScroll, { passive: true })
        return () => { window.removeEventListener("scroll", handleScroll) }
    }, [])

    return (
        <button className={`${styles.button} ${showButton ? styles.show : ''}`} onClick={scrollToTop} aria-label="Back to top">
            <BsArrowUpShort size={20} className={styles.icon} />
        </button>
    )
}

export default BackToTop
